export default __webpack_public_path__ + "static/media/ico-foot-instagram.b84a8a32.svg";